(function ( $ ) {

	var ww = $(window).width();

	$(window).resize(function(){
		ww = $(window).width();
	});

	$.fn.showMenu = function() {
		$this = $(this);
		$menu = $('.js-menu');
		$hamb = $('.js-open-menu');
		$filter = $('.js-filter');

		$(window).resize(function(){
			if (ww >= 992) {
				$menu.removeClass('open');
			}
		});

		$this.on('click', function(){
			$menu.toggleClass('open');
			$hamb.toggleClass('open');
			$('body').toggleClass('oh');
			$filter.fadeToggle()
		});

		$filter.on('click', function(e){
			e.preventDefault();
			$menu.removeClass('open');
			$hamb.removeClass('open');
			$('body').removeClass('oh');
			$(this).fadeOut();
		});

	};
}(jQuery));

(function ( $ ) {

	$.fn.subMenu = function() {
		return this.each(function(){
			var $this = $(this);
			var $ul = $this.next();

			$this.on('click', function(){
				$ul.toggleClass('open');

				var isOpen = $ul.is(':visible'),
					slideDir = isOpen ? 'slideUp' : 'slideDown',
				dur = isOpen ? 200 : 200;
				$ul.velocity(slideDir, {
					easing: [.2,.11,.18,1], 
					duration: dur,
				});

			});
		})
	};
}(jQuery));

$(function() {
	if ($('.js-open-menu').length) {
		$('.js-open-menu').showMenu();
	}
});